import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialShiftingPageState,
  ShiftingItemData,
  ShiftingListResponse,
  ShiftingListStateType,
} from "../core/_model.shifting";

export const defaultPageState = {
  page: 1,
  itemsPerPage: 10,
};

export type ActionedTeam = {
  data: ShiftingItemData | null;
  action: ActionsKey;
};

export type ActionedShifting = {
  data: ShiftingItemData;
  action: ActionsKey;
};

type ShiftingDataType = {
  shiftingList: ShiftingItemData[];
  detail: ShiftingItemData | null;
  actioned: ActionedShifting | null;
  totalItems?: number;
  setDetail: (detail: ShiftingItemData | null) => void;
  setShiftingList: (data: ShiftingListResponse | null) => void;
  setActioned: (act: ActionedTeam | null) => void;
  pageState: typeof defaultPageState;
  setPageState: (state: typeof defaultPageState) => void;
  resetPageState: () => void;
};

export const useShiftingOperationsStore = create<ShiftingDataType>((set) => ({
  shiftingList: [],
  detail: null,
  actioned: null,
  totalItems: 0,
  pageState: defaultPageState,
  setDetail: (detail) => set(() => ({ detail })),
  setShiftingList: (res) =>
    set(() => ({
      shiftingList: res?.member || [],
      totalItems: res?.totalItems ?? 0,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
  setPageState: (pageState) => set(() => ({ pageState })),
  resetPageState: () => set(() => ({ pageState: defaultPageState })),
}));

export const useShiftingOperationsListState = create<ShiftingListStateType>((set) => ({
  pageState: initialShiftingPageState,
  setPageState: (pageState) => set(() => ({ pageState })),
  resetPageState: () => set(() => ({ pageState: initialShiftingPageState })),
}));


{/*
    END OF SHIFTING OPERATION MODEL
______________________________________

    START OF HATCH COVER MODEL
*/}

export const useHatchCoverStore = create<ShiftingDataType>((set) => ({
  shiftingList: [],
  detail: null,
  actioned: null,
  totalItems: 0,
  pageState: defaultPageState,
  setDetail: (detail) => set(() => ({ detail })),
  setShiftingList: (res) =>
    set(() => ({
      shiftingList: res?.member || [],
      totalItems: res?.totalItems ?? 0,
    })),
  setActioned: (act) => set(() => ({ actioned: act } as any )),
  setPageState: (pageState) => set(() => ({ pageState })),
  resetPageState: () => set(() => ({ pageState: defaultPageState })),
}));

export const useHatchCoverListState = create<ShiftingListStateType>((set) => ({
  pageState: initialShiftingPageState,
  setPageState: (pageState) => set(() => ({ pageState })),
  resetPageState: () => set(() => ({ pageState: initialShiftingPageState })),
}));

{/*
    END OF HATCH COVER MODEL
______________________________________

    START OF WAITING TIME MODEL
*/}

export const useWaitingTimeStore = create<ShiftingDataType>((set) => ({
  shiftingList: [],
  detail: null,
  actioned: null,
  totalItems: 0,
  pageState: defaultPageState,
  setDetail: (detail) => set(() => ({ detail })),
  setShiftingList: (res) =>
    set(() => ({
      shiftingList: res?.member || [],
      totalItems: res?.totalItems ?? 0,
    })),
  setActioned: (act) => set(() => ({ actioned: act } as any )),
  setPageState: (pageState) => set(() => ({ pageState })),
  resetPageState: () => set(() => ({ pageState: defaultPageState })),
}));

export const useWaitingTimeListState = create<ShiftingListStateType>((set) => ({
  pageState: initialShiftingPageState,
  setPageState: (pageState) => set(() => ({ pageState })),
  resetPageState: () => set(() => ({ pageState: initialShiftingPageState })),
}));